<template>
  <div class="bordered-layout">
    <!-- Filters -->
    <users-list-filters
      :role-filter.sync="roleFilter"
      :status-filter.sync="statusFilter"
      :online-filter.sync="onlineFilter"
      :ban-filter.sync="banFilter"
      :position-filter.sync="positionFilter"
      :search-query.sync="searchQuery"
      :role-options="roleOptions"
      :status-options="statusOptions"
      :online-options="onlineOptions"
      :ban-options="banOptions"
      :show-role-filter="false"
      :show-ban-filter="false"
      :show-status-filter="false"
      :show-online-filter="false"
      :show-position-filter="true"
      :department-filter.sync="departmentFilter"
      :department-options="departmentOptions"
      :position-options="positionOptions"
      class="mb-0"
    />
    <div class="my-1 d-flex align-items-center">
      <b-button
        variant="outline-primary"
        class="mr-2"
        :disabled="!selectedAll"
        @click="toggleAssignMultiUserToGroup('add')"
      ><feather-icon icon="PlusIcon" /> Thêm tất cả</b-button>
      <b-button
        variant="outline-danger"
        :disabled="!selectedAll"
        class="mr-2"
        @click="toggleAssignMultiUserToGroup('remove')"
      ><feather-icon icon="XIcon" /> Loại bỏ tất cả</b-button>
      <i>Tích chọn nhiều để thêm/loại nhanh</i>

    </div>
    <!-- Table Container Card -->
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card
        no-body
        class="mb-0"
      >
        <b-table
          ref="refUserListTable"
          class="position-relative table-nowrap"
          :items="userItems"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="Không tìm thấy kết quả"
          :sort-desc.sync="isSortDirDesc"
          selectable
          select-mode="multi"
          @row-selected="onRowSelected"
        >

          <!-- A custom formatted header cell for field 'selected' -->
          <template #head(selected)="{ rowSelected }">
            <b-form-checkbox
              v-model="selectedAll"
              value="1"
              unchecked-value="0"
              :checked="rowSelected"
              @change="selectAllRows"
            />
          </template>

          <!-- Column: User -->
          <template #cell(selected)="data">
            <b-form-checkbox
              v-model="selected"
              :value="data.item.id"
              @change="selectRow(data.item.id, data.index)"
            />
          </template>

          <!-- Column: User -->
          <template #cell(user)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                  size="32"
                  :src="defaultAvatar(data.item.avatar)"
                  :text="avatarText(data.item.username)"
                  variant="light-primary"
                />
              </template>
              <b-link class="font-weight-bold d-block text-nowrap">
                {{ data.item.full_name }}
              </b-link>
              <small class="text-muted">@{{ data.item.username }}</small>
            </b-media>
          </template>
          <!-- Column: Department -->
          <template #cell(department_id)="data">
            <span class="font-weight-bold d-block">{{ resolveUserDepartmentText(data.item.department_id) }}</span>
          </template>
          <!-- Column: Position -->
          <template #cell(position_id)="data">
            <span class="font-weight-bold text-capitalize d-block">{{ resolveUserPositionText(data.item.position_id) }}</span>
          </template>

          <!-- Column: Actions -->
          <template
            v-if="$can('group.assignUser', 'Group')"
            #cell(actions)="data"
          >
            <b-button
              v-if="!data.item.group_id.length"
              size="sm"
              variant="outline-primary"
              @click="toggleAssignUser(data.item)"
            >
              <span class="text-nowrap">
                <feather-icon icon="PlusIcon" /> Thêm vào nhóm
              </span>
            </b-button>
            <b-button
              v-else
              size="sm"
              variant="outline-success"
              @click="toggleAssignUser(data.item)"
            >
              <span class="text-nowrap">
                <feather-icon icon="CheckIcon" /> Đã thêm vào nhóm
              </span>
            </b-button>
          </template>

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('show_to_entries', { from: dataMeta.from, to: dataMeta.to, of: dataMeta.of }) }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="currentPage"
                :total-rows="totalEntries"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BOverlay, BCard, BRow, BCol, BAvatar, BButton, BTable,
  BPagination, BMedia, BLink, BFormCheckbox, VBTooltip,
} from 'bootstrap-vue'
import { ref, watch } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import { useRouter, defaultAvatar } from '@/@core/utils/utils'
import _ from 'lodash';
import store from '@/store'
import UsersListFilters from '../users/UsersListFilters.vue'
import useUsers from '../users/useUsers'
import useGroups from './useGroups';

export default {
  components: {
    UsersListFilters,
    BOverlay,
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BPagination,
    BAvatar,
    BMedia,
    BLink,
    BFormCheckbox,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    groupId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isShowModal: false,
    }
  },
  setup() {
    const { route } = useRouter();
    const isAddNewUserSidebarActive = ref(false)
    const userItems = ref([]);
    const selected = ref([]);
    const selectedAll = ref(0);
    const tableColumns = [
      { key: 'selected', sortable: false, thAttr: { width: '40' } },
      { key: 'id', sortable: true, thAttr: { width: '40' } },
      {
        key: 'user',
        sortable: true,
        label: 'Họ tên',
      },
      {
        key: 'department_id',
        label: 'Phòng ban',
        sortable: false,
        thAttr: { width: 250 },
      },
      {
        key: 'position_id',
        sortable: false,
        label: 'Vị trí',
        thAttr: { width: 250 },
      },
      {
        key: 'actions',
        label: 'Hành động',
        thAttr: { width: '100' },
        thClass: 'text-right',
        tdClass: 'text-right',
      },
    ];
    const {
      assignUserToGroup,
    } = useGroups();

    const {
      roleOptions,
      loading,
      fetchPositions,
      fetchDepartmentTrees,
      perPage,
      currentPage,
      totalEntries,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,
      resolveUserStatusText,
      resolveUserRoleName,
      resolveUserOnlineVariant,
      resolveUserBanVariant,
      resolveUserBanText,
      resolveUserDepartmentText,
      resolveUserPositionText,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
      onlineFilter,
      onlineOptions,
      banFilter,
      banOptions,
      departmentOptions,
      departmentFilter,
      statusOptions,
      positionFilter,
      positionOptions,
    } = useUsers(false)

    const fetchUsers = () => {
      loading.value = true;
      store
        .dispatch('groups/fetchGroupUsers', {
          id: route.value.params.id,
          params: {
            keyword: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
            department_id: departmentFilter.value,
            position_id: positionFilter.value,
            role_id: roleFilter.value,
            isPaginate: 1,
            full: 1,
          },
        })
        .then((response) => {
          loading.value = false;
          if (response.status === 200) {
            const items = response.data.data.data;
            const { total } = response.data.data;
            totalEntries.value = total;
            userItems.value = items;
          }
        });
    }
    fetchDepartmentTrees();
    fetchPositions();
    fetchUsers();

    watch([sortBy, isSortDirDesc, currentPage, perPage, searchQuery, departmentFilter, roleFilter, positionFilter], () => {
      fetchUsers();
    });

    return {
      loading,
      statusOptions,
      roleOptions,
      userItems,
      departmentOptions,
      departmentFilter,
      // Sidebar
      isAddNewUserSidebarActive,
      tableColumns,
      perPage,
      currentPage,
      totalEntries,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      fetchUsers,
      assignUserToGroup,
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,
      resolveUserStatusText,
      resolveUserRoleName,
      resolveUserOnlineVariant,
      resolveUserBanVariant,
      resolveUserBanText,
      resolveUserDepartmentText,
      resolveUserPositionText,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
      onlineFilter,
      onlineOptions,
      banFilter,
      banOptions,
      defaultAvatar,
      selected,
      selectedAll,
      positionFilter,
      positionOptions,
    }
  },
  methods: {
    toggleAssignMultiUserToGroup(action) {
      this.assignUserToGroup(
        this.$route.params.id,
        {
          userId: this.selected,
          action,
        },
        () => {
          this.selectedAll = false
          this.fetchUsers()
          // this.$emit('reload-users');
        },
      )
    },
    toggleAssignUser(user) {
      this.loading = true;
      this.assignUserToGroup(
        this.$route.params.id,
        {
          userId: user.id,
        },
        (res) => {
          this.loading = false;
          user.group_id = res.group_id
        },
      )
    },
    onRowSelected(items) {
      // this.selected = items
      this.selected = [];
      items.forEach(item => {
        this.selected.push(item.id);
      });
    },
    selectAllRows() {
      if (this.selectedAll === '1') {
        this.$refs.refUserListTable.selectAllRows();
      } else {
        this.clearSelected();
      }
    },
    clearSelected() {
      this.selected = [];
      this.$refs.refUserListTable.clearSelected()
    },
    selectRow(id, idx) {
      // eslint-disable-next-line no-underscore-dangle
      const _idx = _.indexOf(this.selected, id);
      if (_idx >= 0) {
        this.$refs.refUserListTable.selectRow(idx);
      } else {
        // _.remove(this.selected, (_id) => _id === id);
        this.$refs.refUserListTable.unselectRow(idx);
      }
    },

  },

}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
